import * as actionType from '../action-type';

const initialState = {
  data: {
    attachments: [],
    Allimagedescription: {},
    footerLogo: [],
    // Mohawk-specific defaults
    formData: {},
  },
};

const mohawkFieldServiceReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_MOHAWK_FIELD_SERVICE_REPORT:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case actionType.RESET_MOHAWK_FIELD_SERVICE_REPORT:
      return initialState;
    default:
      return state;
  }
};

export default mohawkFieldServiceReportReducer;